import agentApiService from "../../../../services/travel/new-policy/agentApiService";
import clientApiService from "../../../../services/travel/new-policy/clientApiService";
import { NewTravelPolicyState, ReferralDetails } from "../../../../types/travel/Policy";

const createReferral = (clientId: string, referralDetails: ReferralDetails, flowState: NewTravelPolicyState) =>
  clientId ? clientApiService.createReferral(clientId, referralDetails, flowState) : agentApiService.createReferral(referralDetails, flowState);

export default createReferral;
